import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import {
  setIsFeaturesActive,
  setIsFeaturesActiveSetted,
  setSelectedApp
} from "../../../state/ducks";

import { dispatch } from "../../../state/store";

import { appsService, notificationService, t } from "../../../services";
import { responseUtil } from "../../../utils";
import { appManageTypes, strCode } from "../../../consts";

import { WrapperContainer } from "../../../components";

import FeaturesControl from "./Features/FeaturesControl";
import FeaturesList from "./Features/FeaturesList/FeaturesList";
import FeaturesModal from "./Features/FeaturesModal/FeaturesModal";
import FeaturesDeactivatingModal from "./Features/FeaturesDeactivatingModal/FeaturesDeactivatingModal";

const Features = () => {
  const isFeaturesActive = useSelector((store) => store.apps.isFeaturesActive);
  const isFeaturesActiveSetted = useSelector((store) => store.apps.isFeaturesActiveSetted);
  const features = useSelector((store) => store.apps.selectedApp?.defaultSettings || []);
  const customFeatures = useSelector((store) => store.apps.selectedApp?.customFeatures || []);
  const selectedApp = useSelector((store) => store.apps.selectedApp);
  const manageType = useSelector((store) => store.apps.manageType);
  const lastActiveIndex = useSelector((store) => store.apps.lastActiveIndex);

  const [isFeaturesModalOpened, setIsFeaturesModalOpened] = useState(false);
  const [isFeaturesDeactivatingModalOpened, setIsFeaturesDeactivatingModalOpened] = useState(false);

  useEffect(() => {
    if (
      (manageType !== appManageTypes.EDIT &&
        manageType !== appManageTypes.FROM_EXISTING &&
        !features.length &&
        !isFeaturesActiveSetted) ||
      (manageType === appManageTypes.EDIT &&
        !isFeaturesActiveSetted &&
        (features.length || customFeatures.length))
    ) {
      dispatch(setIsFeaturesActive(true));
      dispatch(setIsFeaturesActiveSetted(true));
    }
  }, [manageType, features]);

  const onFeaturesListToggle = () => {
    if (!isFeaturesActive) {
      dispatch(setIsFeaturesActive(true));
    } else {
      if (!features?.length) {
        dispatch(setIsFeaturesActive(false));
      } else {
        setIsFeaturesDeactivatingModalOpened(true);
      }
    }
  };

  const onFeaturesDeactivating = async () => {
    let res = null;

    if (manageType === appManageTypes.EDIT || lastActiveIndex > 0) {
      res = await appsService.updateApp({
        appType: selectedApp.appType,
        name: selectedApp.name,
        defaultSettings: []
      });
    }

    if ((res && responseUtil.isResponseSuccessful(res)) || manageType !== appManageTypes.EDIT) {
      notificationService.showSuccess({
        title: t(strCode.CONFIGURATION_DISABLED_TITLE)
      });

      dispatch(
        setSelectedApp({
          ...selectedApp,
          defaultSettings: [],
          marketConfigs: selectedApp.marketConfigs?.map((config) => {
            return { ...config, settings: [] };
          })
        })
      );

      dispatch(setIsFeaturesActive(false));

      setIsFeaturesDeactivatingModalOpened(false);
    }
  };

  const sortedFeatures = useMemo(() => {
    return [...features].sort((first) => (!first.value ? 1 : -1));
  }, [features]);

  const onDownload = useCallback(() => {
    const blobData = new Blob(
      [JSON.stringify({ features: sortedFeatures, custom: customFeatures }, null, 2)],
      {
        type: "application/json"
      }
    );

    const downloadLink = document.createElement("a");

    downloadLink.href = URL.createObjectURL(blobData);
    downloadLink.download = "config.json";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }, [sortedFeatures]);

  return (
    <WrapperContainer width="100%">
      <FeaturesControl
        isFeaturesListOpened={isFeaturesActive}
        toggleIsFeaturesListOpened={onFeaturesListToggle}
        onFeaturesModalOpen={() => setIsFeaturesModalOpened(true)}
        onDownload={onDownload}
        hasFeatures={features.length > 0 || customFeatures.length > 0}
      />

      {isFeaturesActive && <FeaturesList onModalOpen={() => setIsFeaturesModalOpened(true)} />}

      <FeaturesModal
        isActive={isFeaturesModalOpened}
        setActive={() => setIsFeaturesModalOpened(false)}
      />

      <FeaturesDeactivatingModal
        isActive={isFeaturesDeactivatingModalOpened}
        onCancel={() => setIsFeaturesDeactivatingModalOpened(false)}
        onDeactivating={onFeaturesDeactivating}
      />
    </WrapperContainer>
  );
};

export default Features;
